<template>
  <span class="text-center" :data-price-symbol="symbol">
    <span>{{ symbol }} {{ fixed }}</span>
    <span class="text-xs text-gray-600">{{ text }}</span>
  </span>
</template>
<script setup lang="ts">
import {
  PlanDisplaysCurrenciesEnum,
  type StripePhonePlanProductItemCurrencyEnum as StripePhonePlanProductCurrencyEnum,
} from '@mailslurp/admin-sdk';
import { computed } from 'vue';

const props = defineProps<{
  symbol: string | null;
  multiplier: number;
  unitPrice: number;
  currency:
    | StripePhonePlanProductCurrencyEnum
    | PlanDisplaysCurrenciesEnum
    | string;
  text: string;
}>();
const perUnitCost = (price: number) => {
  if (
    props.currency?.toString() === PlanDisplaysCurrenciesEnum.JPY.toString()
  ) {
    return price * (props.multiplier ?? 1);
  } else {
    return (price * (props.multiplier ?? 1)) / 100;
  }
};
const fixed = computed(() => {
  return perUnitCost(props.unitPrice).toFixed(2);
});
</script>
